import getReadableColor from "../../../../../components/ui/color-picker/getReadableColor";
import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: ${({ borderRadius }) => `${borderRadius}px`};
  padding: 24px 28px;
  background-color: ${({ color, theme }) =>
    color || (theme.name === "dark" ? "#2a2a2a" : "#f9f9f9")};
  border: 0.71px solid ${({ theme }) => theme.border.black10};
  column-gap: 32px;
  width: 100%;
  box-sizing: border-box;
`;

export const IconText = styled.div`
  display: flex;
  align-items: center;
  column-gap: 14px;
  flex: 1;
`;

export const TitleText = styled.div`
  display: flex;
  flex-direction: column;
  color: ${({ clr, theme }) => clr || theme.text.input};
  flex: 1;
`;

export const TimerButton = styled.div`
  display: flex;
  align-items: center;
  column-gap: 22px;
  flex-shrink: 0;
  color: inherit;
`;

export const Title = styled.div`
  color: inherit;
  font-size: 18.22px;
  font-weight: 600;
  line-height: 20.497px;
  position: relative;
  padding-top: ${({ hasText }) => (hasText ? "0px" : "10px")};
`;

export const Text = styled.div`
  color: inherit;
  font-size: 14px;
  font-weight: 500;
  line-height: 130%;
  position: relative;
`;

export const Button = styled.div`
  padding: 10px 20px;
  border-radius: 24px;
  display: grid;
  place-content: center;

  background-color: ${({ bgClr }) => bgClr};
  color: ${({ bgClr, clr, theme, matchColor }) =>
    matchColor ? getReadableColor(bgClr) : clr || theme.text.input};
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  line-height: 23.202px; /* 165.726% */
  letter-spacing: -0.5px;
  cursor: pointer;
`;

export const IconEmojiContainer = styled.div`
  display: grid;
  place-content: center;

  svg {
    color: ${({ clr, theme }) => clr || theme.text.input};
  }
`;

export const Emoji = styled.div`
  position: relative;
  font-size: 45px;
  cursor: default;
`;
